export const LAWYER_OUTREACH_REPLIES_QUERY_KEY = [
  'admin',
  'lawyer-outreach-replies',
] as const;

const STORAGE_KEY = 'cp.admin.lawyer_outreach.replies_last_opened_at';

export const LAWYER_OUTREACH_REPLIES_OPENED_EVENT =
  'lawyer-outreach-replies-opened';

export type LawyerOutreachReplyForUnread = {
  received_at: string | null;
};

export function getLawyerOutreachRepliesLastOpenedAt(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return localStorage.getItem(STORAGE_KEY);
}

export function setLawyerOutreachRepliesLastOpenedAt(
  at: string = new Date().toISOString(),
): void {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(STORAGE_KEY, at);
  window.dispatchEvent(
    new CustomEvent(LAWYER_OUTREACH_REPLIES_OPENED_EVENT, { detail: at }),
  );
}

export function countUnreadLawyerOutreachReplies(
  replies: LawyerOutreachReplyForUnread[],
  lastOpenedAt: string | null,
): number {
  if (!replies.length) {
    return 0;
  }

  const openedMs = lastOpenedAt ? Date.parse(lastOpenedAt) : Number.NaN;
  const hasValidOpenedAt = lastOpenedAt !== null && !Number.isNaN(openedMs);

  return replies.filter((reply) => {
    if (!reply.received_at) {
      return false;
    }
    const receivedMs = Date.parse(reply.received_at);
    if (Number.isNaN(receivedMs)) {
      return false;
    }
    if (!hasValidOpenedAt) {
      return true;
    }
    return receivedMs > openedMs;
  }).length;
}

export function hasUnreadLawyerOutreachReplies(
  replies: LawyerOutreachReplyForUnread[],
  lastOpenedAt: string | null,
): boolean {
  return countUnreadLawyerOutreachReplies(replies, lastOpenedAt) > 0;
}
